<template>
  <div class="logs">
    <router-view />
    <div class="content--main">
      <p v-if="logs.length == 0">
        No transaction recorded for today
      </p>
      <p v-for="log in logs" :key="log.id">
        <img src="@/assets/media/icons/clock.svg" alt="clock icon" />
        {{ log }}
      </p>
    </div>
  </div>
</template>

<script>
import moment from "@/helpers/moment";
import axios from "@/helpers/axios";
import _ from "lodash";
import { dateUTCComplete } from "@/helpers/date";

export default {
  name: "Logs",
  data: () => ({
    logs: []
  }),
  created() {
    this.getTenantLogs();
  },
  async mounted() {
    let socketOns = [
      "notifyPaidOrder",
      "notifyOrder",
      "notifyCancelOrder",
      "notifyNewMember",
      "notifyUserRegister",
      "notifyUserLogin",
      "notifyUserLogout",
      "notifyUserUpdate",
      "notifyLog",
      "notifyNewEvent",
      "notifyRemoveEvent"
    ];
    socketOns.forEach(async event => {
      await this.$socket.on(event, async () => {
        await this.getTenantLogs();
      });
    });
  },
  methods: {
    async getTenantLogs() {
      this.logs = [];
      let date = moment(dateUTCComplete(new Date())).format("YYYY-M-D");
      let query = await axios.get(`/logs?tenant=${this.$tenant}&date=${date}`);
      let logs = _.reverse(query.data.logs);
      if (query.status == 200 && query.data.status != "Missing log file") {
        logs.forEach(element => {
          let log = element.split(" = ");
          let time = log[0] + "";
          let dateTime = moment(dateUTCComplete(time)).format(
            "MMMM DD YYYY, dddd - h:mm:ss A"
          );
          let completeLog = dateTime + ": " + log[1];
          this.logs.push(completeLog);
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.logs {
  padding: 0 15px;
  .content--main {
    height: calc(
      100vh - 183px
    ); /* height of viewport minus the sum of nav.header and .content--header */
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: 20px;
    padding-top: 20px;
    p {
      color: $gray-900;
      border-bottom: 1px solid $gray-200;
      font-family: "Gotham";
      font-size: $font-size-xs;
      margin: 0;
      padding: 15px 0;
      img {
        height: 10px;
        width: 10px;
      }
    }
  }
}
</style>
